import { HSConfiguration } from './HSConfiguration';

export class SlidingDoorConfiguration extends HSConfiguration {
    type: 'sliding_door' = 'sliding_door';
}
